import React from 'react'
import './index.css'
import { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import { Image,Modal } from 'react-bootstrap'
import img from '../../img/COMPLEMENT_DOCS02.jpg'
import img2 from '../../img/PRE_INSCRIPTION.jpg'
import img3 from '../../img/MODIFIER_MON_DOC.jpg'

const HomeIns = () => {
    const navigate = useNavigate();
    const [delay, setDelay] = useState('');
    const handleClose3 = () => setDelay(false);
    const Delay = () => {
        return (
          <>
            <Modal show={delay} onHide={handleClose3}>
                    <Modal.Body className='alert alert-danger'> Lés inscriptions sont clôturées ! </Modal.Body>
                </Modal>
          </>
        )
      }
    const handleDelay = (e) => {
        if (e.target) {
          setDelay(true)
        }
        console.log('Lés dépots sont clôturés ! ')
      }
  return (
    <div id="MainPage" className='container p-2'>
        {Delay()}
        <div id='PageBody' className='container row row-cols-4'>
            <div className='col ouvert' >
            <Link to="https://etudiant.uam.sn/user/preinscription" target="_blank">
              <Image src={img2} />
          </Link>
                
                </div>
            <div className='col ouvert' onClick={() => {navigate('/inscription')}}>
                <Image src={img} />
                </div>
            {/* <div className='col' onClick={() => {navigate('/updateInscription')}} >
                <Image src={img3} />
                </div> */}
                
        </div> 
        <div>
        </div>
    </div>
  )
}

export default HomeIns